import React from 'react'

const Reports = () => {
  return (
    <div>
      <h1>This is reports area.</h1>
    </div>
  )
}

export default Reports
